import {
    amber,
    blue,
    blueGrey,
    brown,
    cyan,
    deepPurple,
    green,
    indigo,
    lightGreen,
    lime,
    orange,
    pink,
    purple,
    red,
    teal,
    yellow,
} from '@mui/material/colors';
import { getRandomElement } from './common';

/* tslint:disable:cyclomatic-complexity */
export const getColor = (code: string, accent: boolean = false, level: number | null = null): string => {
    if (!code) return blue[100];
    if (code.startsWith('#')) return code;
    const [name, num] = code.split('_');
    const colorLevelBase = level ?? +num;
    const colorLevel = accent ? colorLevelBase + 100 : colorLevelBase;

    switch (name.toLowerCase()) {
        case 'red':
            return colorLevel in red ? (red as any)[colorLevel] : red[100];
        case 'pink':
            return colorLevel in pink ? (pink as any)[colorLevel] : pink[100];
        case 'purple':
            return colorLevel in purple ? (purple as any)[colorLevel] : purple[100];
        case 'deeppruple':
            return colorLevel in deepPurple ? (deepPurple as any)[colorLevel] : deepPurple[100];
        case 'indigo':
            return colorLevel in indigo ? (indigo as any)[colorLevel] : indigo[100];
        case 'blue':
            return colorLevel in blue ? (blue as any)[colorLevel] : blue[100];
        case 'cyan':
            return colorLevel in cyan ? (cyan as any)[colorLevel] : cyan[100];
        case 'teal':
            return colorLevel in teal ? (teal as any)[colorLevel] : teal[100];
        case 'green':
            return colorLevel in green ? (green as any)[colorLevel] : green[100];
        case 'lime':
            return colorLevel in lime ? (lime as any)[colorLevel] : lime[100];
        case 'yellow':
            return colorLevel in yellow ? (yellow as any)[colorLevel] : yellow[100];
        case 'amber':
            return colorLevel in amber ? (amber as any)[colorLevel] : amber[100];
        case 'orange':
            return colorLevel in orange ? (orange as any)[colorLevel] : orange[100];
        case 'brown':
            return colorLevel in brown ? (brown as any)[colorLevel] : brown[100];
        case 'lightgreen':
            return colorLevel in lightGreen ? (lightGreen as any)[colorLevel] : lightGreen[100];
        default:
            return colorLevel in blueGrey ? (blueGrey as any)[colorLevel] : blueGrey[100];
    }
};

export const allowedColors = [
    'RED_200',
    'RED_300',
    'RED_400',
    'RED_500',
    'RED_600',
    'RED_700',
    'PINK_200',
    'PINK_300',
    'PINK_400',
    'PINK_500',
    'PINK_600',
    'PINK_700',
    'PURPLE_200',
    'PURPLE_300',
    'PURPLE_400',
    'PURPLE_500',
    'PURPLE_600',
    'PURPLE_700',
    'DEEPPRUPLE_200',
    'DEEPPRUPLE_300',
    'DEEPPRUPLE_400',
    'DEEPPRUPLE_500',
    'DEEPPRUPLE_600',
    'DEEPPRUPLE_700',
    'INDIGO_200',
    'INDIGO_300',
    'INDIGO_400',
    'INDIGO_500',
    'INDIGO_600',
    'INDIGO_700',
    'BLUE_200',
    'BLUE_300',
    'BLUE_400',
    'BLUE_500',
    'BLUE_600',
    'BLUE_700',
    'CYAN_200',
    'CYAN_300',
    'CYAN_400',
    'CYAN_500',
    'CYAN_600',
    'CYAN_700',
    'TEAL_200',
    'TEAL_300',
    'TEAL_400',
    'TEAL_500',
    'TEAL_600',
    'TEAL_700',
    'GREEN_200',
    'GREEN_300',
    'GREEN_400',
    'GREEN_500',
    'GREEN_600',
    'GREEN_700',
    'LIME_200',
    'LIME_300',
    'LIME_400',
    'LIME_500',
    'LIME_600',
    'LIME_700',
    'YELLOW_200',
    'YELLOW_300',
    'YELLOW_400',
    'YELLOW_500',
    'YELLOW_600',
    'YELLOW_700',
    'AMBER_200',
    'AMBER_300',
    'AMBER_400',
    'AMBER_500',
    'AMBER_600',
    'AMBER_700',
    'ORANGE_200',
    'ORANGE_300',
    'ORANGE_400',
    'ORANGE_500',
    'ORANGE_600',
    'ORANGE_700',
    'BROWN_200',
    'BROWN_300',
    'BROWN_400',
    'BROWN_500',
    'BROWN_600',
    'BROWN_700',
    'LIGHTGREEN_200',
    'LIGHTGREEN_300',
    'LIGHTGREEN_400',
    'LIGHTGREEN_500',
    'LIGHTGREEN_600',
    'LIGHTGREEN_700',
];

export const getRandomColor = () => getRandomElement(allowedColors);

const allowedColors500 = allowedColors.filter(c => c.endsWith('_500'));

const colorKeywordAliases: Record<string, string> = { deeppruple: 'deeppurple' };

export const resolveColorFromKeyword = (keyword: string): string => {
    const raw = keyword.trim().replace(/\s+/g, '');
    if (allowedColors.includes(raw)) return raw;
    const k = (colorKeywordAliases[raw.toLowerCase()] ?? raw.toLowerCase());
    const match = allowedColors500.find(c => c.toLowerCase().startsWith(k + '_') || c.toLowerCase().replace(/_500$/, '') === k);
    return match ?? getRandomColor();
};

export function shadeColor(color: `#${string}`, percent: number): `#${string}` {
    let R = parseInt(color.substring(1, 3), 16);
    let G = parseInt(color.substring(3, 5), 16);
    let B = parseInt(color.substring(5, 7), 16);

    R = parseInt(((R * (100 + percent)) / 100).toString());
    G = parseInt(((G * (100 + percent)) / 100).toString());
    B = parseInt(((B * (100 + percent)) / 100).toString());

    R = R < 255 ? R : 255;
    G = G < 255 ? G : 255;
    B = B < 255 ? B : 255;

    R = Math.round(R);
    G = Math.round(G);
    B = Math.round(B);

    const RR = R.toString(16).length == 1 ? '0' + R.toString(16) : R.toString(16);
    const GG = G.toString(16).length == 1 ? '0' + G.toString(16) : G.toString(16);
    const BB = B.toString(16).length == 1 ? '0' + B.toString(16) : B.toString(16);

    return `#${RR}${GG}${BB}`;
}
